const utilities = {

	/**
	 * Helper function to get the height of an element
	 *
	 * @param {HTMLElement} element The Node
	 * @param DOMRect union of the rectangles
	 * @return {number} The height of the element
	 */
	getHeight: (element, DOMRect) => {
		return element.scrollHeight || DOMRect.scrollHeight || DOMRect.height || element.offsetHeight;
	},

	/**
	 * Helper function to get the width of an element
	 *
	 * @param {HTMLElement} element The node
	 * @param DOMRect union of the rectangles
	 * @return {number} The width of the element
	 */
	getWidth: (element, DOMRect) => {
		return DOMRect.width || element.offsetWidth;
	},

	/**
	 * Helper function to get the top of the element
	 *
	 * @param {HTMLElement} element The node
	 * @param DOMRect union of the rectangles
	 * @return {number} The top position of the element
	 */
	getTop: (element, DOMRect) => {
		return DOMRect.top || element.top;
	},

	/**
	 * Helper function to get the left of the element
	 *
	 * @param {HTMLElement} element The node
	 * @param {object} DOMRect union of the rectangles
	 * @return {number} The left position of the element
	 */
	getLeft: (element, DOMRect) => {
		return DOMRect.left || element.left;
	},

	/**
	 * Helper function to determine the size of an element
	 *
	 * @param {HTMLElement} element The node
	 * @return {{width: (number), height: (number), top: {number}, left: {number}}}
	 */
	getElementSize: (element) => {
		let DOMRect = element.getBoundingClientRect();
		let width = utilities.getWidth(element, DOMRect);
		let height = utilities.getHeight(element, DOMRect);
		let top = utilities.getTop(element, DOMRect);
		let left = utilities.getLeft(element, DOMRect);

		return {
			width,
			height,
			top,
			left,
		};
	},

};

export default utilities;
